module.exports = __webpack_public_path__ + "static/30invgde-45c6133ca7dee6d9f6b0ffd0e74e85df.gif";